import {
	ChangeDetectionStrategy,
	Component,
	EventEmitter,
	Input,
	OnChanges, OnDestroy,
	OnInit,
	Output,
	SimpleChanges
} from "@angular/core";
import {RtlService} from "../../../rtl/services/rtl.service";
import {TranslateService} from "../../../translate";
import {DateHelperService, DateMode, IDateRange} from "../../services/date.helper.service";

// TODO: to discuss with Shahar & Dima
import {IDay} from "../../../../app.services/scheduling.config/schedule.modality.groups.manager/interfaces/schedule.modality.availability.entry";
import {BrowserAttributes} from "../../../browser/detect.browser";
import {Subject} from "rxjs";
import {debounceTime} from "rxjs/operators";
import {UntilDestroy, untilDestroyed} from "@ngneat/until-destroy";
import {SystemConfigurationValues} from "../../../configuration/services/system.configuration.utils";
import {Align} from "@progress/kendo-angular-popup";

@UntilDestroy()
@Component({
	selector: "cp-date-nav",
	templateUrl: './date.nav.template.html',
	styleUrls: ['./date.nav.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DateNavigatorComponent implements OnChanges, OnInit, OnDestroy {

	@Input() date: Date = new Date();
	@Input() dateMode: DateMode = DateMode.Default;
	@Input() navigationModeOnly: boolean = false;
	@Input() weekDays: IDay[] = []; // TODO: to discuss with Shahar & Dima

	@Output() dateChanged =  new EventEmitter<Date|IDateRange>();

	public showCalendar:boolean;
	public popupDir:Align;
	public formattedDateRange: string;

	public get useAnimation(): boolean {
		return !this.browserDetect.isIE();
	}

	private weekDates: Date[] = [];
	private weekDateRange: IDateRange;
	private readonly dateChangedSubject: Subject<Date|IDateRange> = new Subject<Date | IDateRange>();
	private defaultDate: Date;

	constructor(private translateService: TranslateService,
				private rtlService: RtlService,
				private dateHelperService:DateHelperService,
				private browserDetect:BrowserAttributes,
				private sysConfig: SystemConfigurationValues){

		let dateChangeDebounceTime: number = sysConfig.getNumber("WorklistDateChangeDebounceMillisec", 700);

		this.dateChangedSubject.pipe(debounceTime(dateChangeDebounceTime), untilDestroyed(this))
			.subscribe((date) => {
					this.dateChanged.next(date);
		});
	}

	public ngOnChanges(changes: SimpleChanges) {
		if (this.dateMode !== DateMode.Default) {
			this.weekDates = this.dateHelperService.getAllWeekDaysDates(this.date, this.dateMode, this.weekDays);
			this.weekDateRange = this.dateHelperService.getWeekDateRange(this.date, this.dateMode, this.weekDays);
			this.formattedDateRange = this.dateHelperService.formatDateRange(this.weekDateRange.fromDate, this.weekDateRange.toDate);
		}
	}

	public ngOnInit(){
		this.popupDir = this.rtlService.isRtl() ? {vertical:"top",horizontal:"right"} : {vertical:"top",horizontal:"left"};
		this.defaultDate = this.date; //The the default date as the first date value
	}

	/* ***************************************************************************
	* Public Methods
	* ************************************************************************** */

	public dateSelected(date){
		this.dateChanged.next(date);
		this.showCalendar=false;
	}

	public next() {
		let nextDate: Date = this.dateHelperService.getNextDate(this.date, this.dateMode, this.weekDays);

		if (this.dateMode === DateMode.Default) {
			this.dateChangedSubject.next(nextDate);
		} else {
			this.dateChangedSubject.next(this.dateHelperService.getWeekDateRange(nextDate, this.dateMode, this.weekDays));
		}

		this.date = nextDate;
	}

	public previous() {
		let previousDate: Date = this.dateHelperService.getPreviousDate(this.date, this.dateMode, this.weekDays);

		if (this.dateMode === DateMode.Default) {
			this.dateChangedSubject.next(previousDate);
		} else {
			this.dateChangedSubject.next(this.dateHelperService.getWeekDateRange(previousDate, this.dateMode, this.weekDays));
		}

		this.date = previousDate;
	}

	public markerFunction = (date: Date): string => {
		return this.dateHelperService.getWeekDateMarkerClass(date, this.date, this.dateMode, this.weekDays);
	}

	public isNonDefaultDate(): boolean {
		return  !this.dateHelperService.isSameDates(this.defaultDate, this.date);
	}

	ngOnDestroy(): void {
	}
}

